import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import React from 'react';
import { config } from '../config';

const buildDate = formatBuildDate(config.BUILD_DATE);

export default function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="">
          Suelos y pavimentos
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        align="center"
        display="block">
        Build {config.GIT_HASH}
        {buildDate && ` (${buildDate})`}
      </Typography>
    </>
  );
}

function formatBuildDate(isoDate: string): string {
  if (!isoDate) return '';
  return new Date(isoDate)
    .toLocaleDateString('es', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
    .toLowerCase()
    .replace(/\./g, '');
}
